export default __webpack_public_path__ + "static/media/CarPolishing.f9ea4e33.jpg";